import script from "./MainNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainNotification.vue?vue&type=script&setup=true&lang=ts"

import "./MainNotification.vue?vue&type=style&index=0&id=519d0783&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-519d0783"]])

export default __exports__